import React, { PropTypes } from 'react';
import Code from 'components/Helpers/Code/Code';
import Page from 'components/Page/Page';

const Article = ({ data }) => {
  const style = require('./Article.scss');
  return (
    <div className={style.baseStyles}>
      <Page data={data.page} />
      {
      data.code !== undefined && <Code>{JSON.stringify(data, null, 2)}</Code>
      }
    </div>
  );
};

Article.propTypes = {
  data: PropTypes.object
};

export default Article;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/containers/Article/Article.js
 **/